import { createORPCClient } from "@orpc/client";
import type { ContractRouterClient } from "@orpc/contract";
import {
  recordingsContract,
  type RecordingsContract,
} from "@typedoc/contracts/recordings/contract";
import { contractLink, type ContractCallContext } from "../contract-client";

export type RecordingsApiClient = ContractRouterClient<RecordingsContract, ContractCallContext>;

/** The Recordings API through its contract; each call names its region and token. */
export const recordingsApiClient: RecordingsApiClient = createORPCClient(
  contractLink(recordingsContract),
);
